/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function InlineElementIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "inline-element", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("rect", { x: 8.5, y: 6.5, width: 8, height: 12, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M5.5 5V20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M19.5 5V20", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(InlineElementIcon);
export default ForwardRef;
//# sourceMappingURL=inlineElementIcon.js.map